import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminOrganizationUsersResponse } from '@utils/types/admin';

/**
 * Hook to fetch users in an on-prem organization
 *
 * GET /api/admin/on-prem/organizations/{id}/users
 *
 * Returns list of users in the organization
 */
export const useGetAdminOrganizationUsers = (
  organizationId: string | number,
  offset: number = 0,
  limit: number = 25
) => {
  const fetchUsers = async () => {
    const params = new URLSearchParams();
    params.append('offset', String(offset));
    params.append('limit', String(limit));

    const url = `api/admin/on-prem/organizations/${organizationId}/users?${params.toString()}`;
    const response = await Axios.get<AdminOrganizationUsersResponse>(url);
    return response.data;
  };

  return useQuery<AdminOrganizationUsersResponse, AxiosError<BaseError>>(
    ['adminOrganizationUsers', organizationId, offset, limit],
    fetchUsers,
    {
      useErrorBoundary: false,
      enabled: !!organizationId
    }
  );
};
